const STORAGE_KEY = 'safeguardpro_journals_v1';

const readEntries = () => {
  if (typeof window === 'undefined') return [];
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    return [];
  }
};

const writeEntries = (entries) => {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
};

const normalizeRecipients = (recipients = []) =>
  recipients.map((recipient) => ({
    id: recipient.id,
    name: recipient.name || 'Unknown'
  }));

const normalizeEntry = (entry) => ({
  id: entry.id || `journal-${Math.random().toString(36).slice(2, 10)}`,
  studentId: entry.studentId,
  studentName: entry.studentName || 'Student',
  authorType: entry.authorType || 'student',
  authorName: entry.authorName || entry.studentName || 'Student',
  authorId: entry.authorId || entry.studentId || null,
  category: entry.category || 'note',
  title: entry.title || '',
  body: entry.body || '',
  createdAt: entry.createdAt || new Date().toISOString(),
  attachments: entry.attachments || [],
  staffRecipients: normalizeRecipients(entry.staffRecipients || []),
  staffRecipientIds: entry.staffRecipientIds || (entry.staffRecipients || []).map((recipient) => recipient.id),
  status: entry.status || 'open',
  approvedBy: entry.approvedBy || null,
  approvedAt: entry.approvedAt || null,
  pointsAwarded: Boolean(entry.pointsAwarded)
});

export default class JournalService {
  list() {
    return readEntries().map((entry) => normalizeEntry(entry));
  }

  listForStudent(studentId) {
    return this.list().filter((entry) => entry.studentId === studentId);
  }

  listForStaff(staffId) {
    return this.list().filter((entry) => (entry.staffRecipientIds || []).includes(staffId));
  }

  createEntry({ student, title, body, category, attachments = [], staffRecipients = [], authorType = 'student', authorName = '', authorId = null }) {
    const entry = normalizeEntry({
      studentId: student.id,
      studentName: student.name,
      authorType,
      authorName: authorName || (authorType === 'staff' ? 'Support team' : student.name),
      authorId: authorId || (authorType === 'staff' ? null : student.id),
      title,
      body,
      category,
      attachments,
      staffRecipients,
      staffRecipientIds: staffRecipients.map((recipient) => recipient.id),
      status: authorType === 'staff' ? 'shared' : category === 'wellbeing' ? 'pending' : 'shared'
    });
    const next = [entry, ...readEntries()];
    writeEntries(next);
    return entry;
  }

  updateEntry(id, updates = {}) {
    const entries = this.list();
    const next = entries.map((entry) => (entry.id === id ? normalizeEntry({ ...entry, ...updates }) : entry));
    writeEntries(next);
    return next.find((entry) => entry.id === id) || null;
  }
}
